export default __webpack_public_path__ + "static/media/KnowBe4.bcd66026.svg";